"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var index_1 = require("../index");
var environment_1 = require("../../../environments/environment");
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(authenticationService, translationService) {
        this.authenticationService = authenticationService;
        this.translationService = translationService;
        this.sections = [];
        this.applicationVersion = environment_1.environment.applicationVersion;
        this.expanded = false;
        this.mobileOpenChange = new core_1.EventEmitter();
        this.expandedChange = new core_1.EventEmitter();
        this.sections = [];
        var fleetPages = [
            { name: this.translationService.instant('Trucks'), icon: null, type: 'link', url: '/trucks' },
            { name: this.translationService.instant('Drivers'), icon: null, type: 'link', url: '/drivers' },
            { name: this.translationService.instant('Fleet Health'), icon: null, type: 'link', url: '/fleet-health' }
        ];
        if (this.hasLeasedOrgs()) {
            fleetPages.push({ name: this.translationService.instant('Leased Fleet'), icon: null, type: 'link', url: '/leased-fleet' });
        }
        if (this.hasTrackables()) {
            fleetPages.push({ name: this.translationService.instant('Trackables'), icon: null, type: 'link', url: '/trackables' });
        }
        var projectPages = [];
        if (this.hasLafargeRegion()) {
            projectPages = projectPages.concat([
                { name: this.translationService.instant('Add Order'), icon: null, type: 'external-link', url: environment_1.environment.ordersUrl }
            ]);
        }
        projectPages = projectPages.concat([
            { name: this.translationService.instant('Daily Board'), icon: null, type: 'link', url: '/jobs/daily' },
            { name: this.translationService.instant('All Jobs'), icon: null, type: 'link', url: '/jobs/all' }
        ]);
        if (this.hasAllDriversEnabled()) {
            projectPages.push({ name: this.translationService.instant('All Drivers'), icon: null, type: 'link', url: '/jobs/drivers' });
        }
        projectPages = projectPages.concat((this.isCarrierMode() ? [
            { name: this.translationService.instant('Active Locations'), icon: null, type: 'link', url: '/jobs/locations/active' },
            { name: this.translationService.instant('Hauler Shares'), icon: null, type: 'link', url: '/jobs/hauler-shares' },
            { name: this.translationService.instant('Received'), icon: null, type: 'link', url: '/jobs/pending' },
        ] : [
            { name: this.translationService.instant('Hauler Shares'), icon: null, type: 'link', url: '/jobs/hauler-shares' },
        ]).concat([
            { name: this.translationService.instant('Dispatch Scheduler'), icon: null, type: 'link', url: '/dispatch-schedule' }
        ]));
        var reportPages = [
            { name: this.translationService.instant('Trips'), icon: null, type: 'link', url: '/trips' },
            { name: this.translationService.instant('GeoTrips'), icon: null, type: 'link', url: '/geotrips' },
            { name: this.translationService.instant('Punch Cards'), icon: null, type: 'link', url: '/punchcards' },
            { name: this.translationService.instant('Shifts'), icon: null, type: 'link', url: '/shifts' },
            { name: this.translationService.instant('Pay Reports'), icon: null, type: 'link', url: '/pay-reports/all' },
            { name: this.translationService.instant('Driver Job Reports'), icon: null, type: 'link', url: '/driver-reports' },
            { name: this.translationService.instant('End of Day Reports'), icon: null, type: 'link', url: '/end-of-day-reports' }
        ];
        if (this.hasRuckit3()) {
            reportPages.push({ name: this.translationService.instant('Advanced Reports'), icon: null, type: 'external-link', url: 'https://integrated-trucking.herokuapp.com/' });
        }
        var billingPages = [
            { name: this.translationService.instant('Invoices'), icon: null, type: 'link', url: '/invoices/filter/draft' },
            { name: this.translationService.instant('Expenses'), icon: null, type: 'link', url: '/expenses/filter/draft' },
            { name: this.translationService.instant('Paystubs'), icon: null, type: 'link', url: '/paystubs/filter/draft' },
            { name: this.translationService.instant('Surcharges'), icon: null, type: 'link', url: '/surcharge-templates' },
        ];
        if (this.hasWorkOrder()) {
            projectPages.push({ name: this.translationService.instant('Work Orders'), icon: null, type: 'link', url: '/work-orders' });
        }
        this.sections = this.sections.concat([
            { name: this.translationService.instant('MENU'), menu: 'top', type: 'heading' },
            { name: this.translationService.instant('Dashboard'), icon: 'icon-dashboard', menu: 'top', type: 'link', url: '/dashboard' },
            { name: this.translationService.instant('Jobs'), icon: 'icon-projects', menu: 'top', type: 'toggle',
                url: '/jobs/daily', pages: projectPages },
            { name: this.translationService.instant('Reports'), icon: 'icon-reports', menu: 'top', type: 'toggle',
                url: '/trips', pages: reportPages },
            { name: this.translationService.instant('Fleet'), icon: 'icon-fleet', menu: 'top', type: 'toggle',
                url: '/trucks', pages: fleetPages }
        ]);
        if (this.hasBillingModule()) {
            this.sections = this.sections.concat([
                { name: this.translationService.instant('Billing'), icon: 'icon-invoices', menu: 'top', type: 'toggle',
                    url: '/invoices/filter/draft', pages: billingPages }
            ]);
        }
        var controlReportPages = [];
        if (this.hasControlReports()) {
            this.sections = this.sections.concat([
                { name: this.translationService.instant('Control Reports'), icon: 'icon-reports', menu: 'top', type: 'toggle',
                    url: '/control-reports', pages: controlReportPages }
            ]);
            controlReportPages.push({ name: this.translationService.instant('Notifications'), icon: null, type: 'link', url: '/control-reports/notifications' });
        }
        this.sections = this.sections.concat([
            {
                name: this.translationService.instant('Accounts'), icon: 'icon-connections', menu: 'top', type: 'toggle', url: '/accounts', pages: [
                    { name: this.translationService.instant('Customers'), icon: null, menu: 'top', type: 'link', url: '/accounts' },
                    { name: this.translationService.instant('Connections'), icon: null, menu: 'top', type: 'link', url: '/connections' },
                ]
            },
            { name: this.translationService.instant('Locations'), icon: 'icon-locations', menu: 'top', type: 'link', url: '/locations' },
            { name: this.translationService.instant('Replay'), icon: 'icon-replay', menu: 'top', type: 'link', url: '/replay' },
            {
                name: 'Ticket Manager', icon: 'icon-ticket', menu: 'top',
                type: 'external-link', url: environment_1.environment.ticketManagerUrl
            }
        ]);
        this.sections = this.sections.concat([
            { name: this.translationService.instant('ORGANIZATION'), menu: 'top', type: 'heading' },
            { name: this.translationService.instant('Team'), icon: 'icon-team', menu: 'top', type: 'link', url: '/team' },
            { name: this.translationService.instant('Settings'), icon: 'icon-settings', menu: 'top', type: 'link',
                url: '/settings/organization'
            },
            {
                name: this.translationService.instant('Live Support'), icon: 'icon-live-support', menu: 'bottom', type: 'click',
            },
            // {
            //   name: this.translationService.instant('Videos'), icon: 'icon-play', menu: 'bottom', type: 'external-link',
            //   url: 'https://fast.wistia.net/embed/channel/7eihjs84gv'
            // },
            { name: this.translationService.instant('Resources'), icon: 'icon-links', menu: 'bottom', type: 'link', url: '/resources' },
            {
                name: this.translationService.instant('Help'), icon: 'icon-help', menu: 'bottom', type: 'external-link',
                url: 'https://mastery.commandalkon.com/ruckit'
            },
        ]);
    }
    SidebarComponent.prototype.ngOnInit = function () {
        this.user = this.authenticationService.user();
    };
    SidebarComponent.prototype.isLoggedIn = function () {
        return this.authenticationService.isLoggedIn();
    };
    SidebarComponent.prototype.hasAllDriversEnabled = function () {
        return this.authenticationService.hasAllDriversEnabled();
    };
    SidebarComponent.prototype.hasLeasedOrgs = function () {
        return this.authenticationService.hasLeasedOrgs();
    };
    SidebarComponent.prototype.hasTrackables = function () {
        return this.authenticationService.hasTrackables();
    };
    SidebarComponent.prototype.hasRuckit3 = function () {
        return this.authenticationService.hasRuckit3() || this.authenticationService.enabledFeatures().includes('hasRuckit3');
    };
    SidebarComponent.prototype.hasLafargeRegion = function () {
        return this.authenticationService.hasLafargeRegion();
    };
    SidebarComponent.prototype.hasWorkOrder = function () {
        return this.authenticationService.hasWorkOrder();
    };
    SidebarComponent.prototype.hasBillingModule = function () {
        return this.authenticationService.hasBillingModule();
    };
    SidebarComponent.prototype.hasControlReports = function () {
        return this.authenticationService.enabledFeatures().includes('hasControlReports');
    };
    SidebarComponent.prototype.isCarrierMode = function () {
        return this.authenticationService.enabledFeatures().includes('ruckitBilling');
    };
    SidebarComponent.prototype.toggleMobileOpen = function () {
        this.mobileOpen = !this.mobileOpen;
        this.mobileOpenChange.emit(this.mobileOpen);
    };
    SidebarComponent.prototype.toggleSidebarExpanded = function () {
        this.expanded = !this.expanded;
        this.expandedChange.emit(this.expanded);
    };
    SidebarComponent.prototype.onMenuClick = function (section) {
        if (section.icon === 'icon-live-support') {
            return void 0;
        }
    };
    return SidebarComponent;
}());
exports.SidebarComponent = SidebarComponent;
